var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalComponent',{attrs:{"name":'editar-precio-' + _vm.precio.id,"title":"Editar precio"},on:{"close":function($event){return _vm.cerrar()}}},[_c('Form',{attrs:{"data":_vm.precio},on:{"terminado":function($event){return _vm.editPrice()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }